import { getCanonicalEditorial } from '@/lib/canonical-experiences'
import type { HomepageExperience } from '@/lib/homepage-experiences'
import { liveDistricts } from '@/lib/live-districts'

export function getExperienceVisitorFacts(experience: HomepageExperience) {
  const editorial = getCanonicalEditorial(experience.slug)
  const live = liveDistricts.includes(experience.district)

  return {
    live,
    duration: editorial?.duration ?? experience.duration,
    price: !live ? 'Price to be announced' : editorial?.price ?? 'Price confirmed before booking',
    groupSize: editorial ? `Up to ${editorial.maxGuests} guests` : live ? 'Group size confirmed on request' : 'Group size to be announced',
  }
}
